import React from 'react';

import { SpillSvg } from '../svgs/spill';

const Icon = () => <SpillSvg width="172px" height="192px" />;

export default Icon;
